var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-overlay',{attrs:{"show":true,"rounded":"sm","no-fade":""}},[_c('div',{staticClass:"login"})])}
var staticRenderFns = []

export { render, staticRenderFns }